import { mobilePopupCRUDApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getMobilePopups = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(mobilePopupCRUDApi + `${query || ""}`, config);

    return response;
};

export const postMobilePopups = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(mobilePopupCRUDApi, data, config);
    return response;
};

export const patchMobilePopups = async ({ data, id }) => {    
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(mobilePopupCRUDApi + id + "/", data, config);
    return response;
};

export const deleteMobilePopups = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(mobilePopupCRUDApi + id + "/", config);

    return response;
};
